import { clsx } from 'clsx';
import { MouseEventHandler, ReactNode } from 'react';

import { ClearIcon } from '@/components/icons/input';
import { useFilterStore } from '@/store';

import cn from './styles.module.sass';

interface IActiveFilterProps {
    children?: ReactNode;
    onClear?: VoidFunction;
    onClick?: VoidFunction;
    disabled?: boolean;
}

export const ActiveFilter = ({ children, onClear, onClick, disabled }: IActiveFilterProps) => {
    const { setCurrentPage, setPrevPage } = useFilterStore();

    const handleClear: MouseEventHandler<HTMLSpanElement> = e => {
        e.stopPropagation();
        if (onClear) {
            setCurrentPage(0);
            setPrevPage(0);
            onClear();
        }
    };

    return (
        <div onClick={onClick} className={clsx(cn.activeFilter, disabled && cn.disabled)}>
            <div className={cn.content}>{children}</div>
            {!disabled && (
                <span onClick={handleClear} className={cn.clearIcon}>
                    {ClearIcon}
                </span>
            )}
        </div>
    );
};
